import "regenerator-runtime/runtime";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
import customizableQuery from '~/graphql/customizable.gql';

function fetchCustomizable(_x, _x2) {
  return _fetchCustomizable.apply(this, arguments);
} // eslint-disable-next-line


function _fetchCustomizable() {
  _fetchCustomizable = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee(context, code) {
    var locale, _ref, data;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            locale = context.state.i18n.currentLocale.iso;
            _context.next = 3;
            return context.app.apolloProvider.defaultClient.query({
              query: customizableQuery,
              variables: {
                locale: locale,
                code: code
              }
            });

          case 3:
            _ref = _context.sent;
            data = _ref.data;
            return _context.abrupt("return", data.customizable);

          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _fetchCustomizable.apply(this, arguments);
}

export { fetchCustomizable };